import { render, staticRenderFns } from "./MaterialModal.vue?vue&type=template&id=0ad4efd0&scoped=true"
import script from "./MaterialModal.vue?vue&type=script&lang=js"
export * from "./MaterialModal.vue?vue&type=script&lang=js"
import style0 from "./MaterialModal.vue?vue&type=style&index=0&id=0ad4efd0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad4efd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad4efd0')) {
      api.createRecord('0ad4efd0', component.options)
    } else {
      api.reload('0ad4efd0', component.options)
    }
    module.hot.accept("./MaterialModal.vue?vue&type=template&id=0ad4efd0&scoped=true", function () {
      api.rerender('0ad4efd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/material/modules/MaterialModal.vue"
export default component.exports